import { ApolloProvider } from '@apollo/client';
import { ReactComponent as SVGs } from '@do/walrus/icons.svg';
import '@do/walrus/style.css';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import client from './client';

if (
  process.env.NODE_ENV === 'production' &&
  process.env.REACT_APP_SENTRY_RELEASE
) {
  Sentry.init({
    environment: process.env.NODE_ENV,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    dsn: 'https://6edc8fb6c85e4294b525726a0698517f@sentry.io/1794139',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.005,
    allowUrls: [/https?:\/\/(([a-zA-Z0-9][a-zA-Z0-9.-]+)\.)?digitalocean\.com/],
    ignoreErrors: [/^Non-Error promise rejection captured with value:/]
  });
}

ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
    <SVGs className="do-u-hidden" />
  </ApolloProvider>,
  document.getElementById('root')
);
